import React from "react";
import "./style.scss";
import TextCaption from "../typography/TextCaption";
import TextTitle from "../typography/TextTitle";

interface IInfoCard {
  background?: string;
  title?: string;
  amount?: string | number;
  isLoading?: boolean;
}

const InfoCardSkeleton = () => {
  return (
    <div className='infoCard skeleton'>
      <div className='infoCard__title'>
        <div className='infoCard__title--indicator skeleton__indicator'></div>
        <div className='skeleton__text skeleton__text--caption'></div>
      </div>
      <div className='skeleton__text skeleton__text--title'></div>
      <div className='d-flex gap-1'>
        <div className='skeleton__icon'></div>
        <div className='skeleton__text skeleton__text--caption'></div>
        <div className='skeleton__text skeleton__text--caption'></div>
      </div>
    </div>
  );
};

const TotalInfoCard = ({
  background = "#F5F5F8",
  title,
  amount,
  isLoading,
}: IInfoCard) => {
  return isLoading ? (
    <InfoCardSkeleton />
  ) : (
    <div className='totalInfoCard' style={{ background }}>
      <div className='totalInfoCard__title'>
        <TextCaption level='3'>{title}</TextCaption>
      </div>
      <TextTitle level='1'>{amount}</TextTitle>
    </div>
  );
};

export default TotalInfoCard;
